module.exports = __webpack_public_path__ + "img/ime_plus_active.a3c6e41d.svg";